import type { WidgetDefinition, WidgetProps } from '@/types/widget';

// Stub widget. Proves the contract end-to-end: config persists via
// onConfigChange, scope filtering works, size prop is respected.

function HelloWorldWidget({ config, onConfigChange, size }: WidgetProps) {
  const greeting = (config.greeting as string) ?? 'Hello, Seitiate+.';
  return (
    <div className="sp-widget">
      <div className="sp-widget-header">
        <span>hello-world</span>
        <span className="mono" style={{ color: 'var(--sp-text-dim)' }}>
          {size.w}&times;{size.h}
        </span>
      </div>
      <div className="sp-widget-body" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 14, marginBottom: 8 }}>{greeting}</div>
          <button
            className="sp-btn"
            onClick={() => onConfigChange({ greeting: `Hello at ${new Date().toLocaleTimeString()}` })}
          >
            Refresh greeting
          </button>
        </div>
      </div>
    </div>
  );
}

export const helloWorldWidget: WidgetDefinition = {
  id: 'hello-world',
  name: 'Hello, world',
  description: 'Smoke-test widget proving the WidgetDefinition contract.',
  icon: 'sparkles',
  category: 'universal',
  scope: 'both',
  defaultSize: { w: 3, h: 2 },
  minSize: { w: 2, h: 2 },
  configSchema: {
    type: 'object',
    properties: {
      greeting: { type: 'string', title: 'Greeting text' },
    },
  },
  component: HelloWorldWidget,
};
